<template>
  <div class="settings">
    <div class="settings__tabs">
      <div
        class="settings__tab"
        @click="currentComponent = 'General'"
        :class="{ 'tab-selected': currentComponent == 'General' }"
      >
        General
      </div>
      <!-- <div class="settings__tab"
      @click="currentComponent='ComisionSP'"
      :class="{'tab-selected':currentComponent=='ComisionSP'}">
      Comisiones SP
    </div> -->
      <div
        class="settings__tab"
        @click="currentComponent = 'Concepto'"
        :class="{ 'tab-selected': currentComponent == 'Concepto' }"
      >
        Conceptos
      </div>

      <div
        class="settings__tab"
        @click="currentComponent = 'Others'"
        :class="{ 'tab-selected': currentComponent == 'Others' }"
      >
        Otras Configuraciones
      </div>
    </div>

    <div class="settings__components">
      <transition name="fade" mode="out-in">
        <keep-alive>
          <!-- no manda data vacia via vmodel !! (Y) -->
          <component :is="currentComponent" v-model="data" v-if="!loading" />
        </keep-alive>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

import General from "@/components/settings/General";
import ComisionSP from "@/components/settings/ComisionSP";
import Concepto from "@/components/settings/Concepto";
import Others from "@/components/settings/Others";

export default {
  components: {
    General,
    ComisionSP,
    Concepto,
    Others,
  },
  created() {
    this.getDetailBusiness(this.$store.state.business.businessId).then((r) => {
      console.log(r);
      if (r.status == 200) {
        console.log("Detalles de empresa obtenidos");
        this.loading = false;
        this.data = this.dataBusiness;
      }
    });
    this.$store.dispatch("displayGaaa");
  },
  data() {
    return {
      currentComponent: "General",
      loading: true,
      data: this.dataBusiness,
    };
  },
  computed: {
    ...mapState({
      dataBusiness: (state) => state.enterprise.dataBusiness,
    }),
  },
  methods: {
    ...mapActions({
      getDetailBusiness: "getDetailBusiness",
    }),
  },
};
</script>

<style lang="scss" scoped>
//1-SETTINGS
//colors
$b-orange: #d8ff00;
$b-blue: #000000;
$b-emph: #97c2c9;
$b-blue-dark: #c63832;
//breakpoints
$sm: 600px;
$md: 900px;
$lg: 1200px;
$xl: 1800px;
//variables
$p-img: "../assets/img/";

//2-VENDORS
.tab-selected {
  background-color: #97c2c9 !important;
  font-weight: 700 !important;
  border: 1px solid rgba($b-blue, 0.75) !important;
  border-bottom: 1px solid #fff !important;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

//3-TOOLS
//functions
//background-image function
@function bimg($img) {
  @return url($p-img + $img);
}
//mixins
@mixin mq($min-width) {
  @media screen and (min-width: $min-width) {
    @content;
  }
}

.settings {
  background-color: #eceff8;
  @include mq($lg) {
    margin: 1.5rem 0 0 3rem;
  }

  &__tabs {
    display: flex;
    flex-wrap: wrap;
    padding: 0 1rem;
    background-color: #fff;
  }
  &__tab {
    padding: 0.5rem 1rem 0.5rem 0.5rem;
    background-color: #e6e6e6;
    color: $b-blue;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    margin-right: 3px;
    margin-top: 0.5rem;
    @include mq($md) {
      cursor: pointer;
    }
  }

  &__components {
    padding: 0 1rem 1rem 1rem;
    background-color: #fff;
    @include mq($sm) {
      padding: 0 3rem 3rem 3rem;
    }
  }
}
</style>
